module.exports = __webpack_public_path__ + "media/images/icon__betPick--none@2x-04d007a448dcdedf9511980c77c64e9f.png";